import Axios from "axios";

export default function DprogramPriority(appliedCounsellingId){
     console.log(appliedCounsellingId);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a:'dprogramPriority',
            appliedCounsellingId
          
        }
    });
    return response;
}